module.exports = __webpack_public_path__ + "img/tg.749ac190.svg";